
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Invoice } from "@/script/apps/user/entity/UserEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { InvoiceService } from "@/script/apps/user/service/InvoiceService";
import { ElMessage } from "element-plus";
import { UserService } from "@/script/apps/system/service/UserService";

@Options({})
export default class InvoiceDetail extends BaseDetail {
  private service = new InvoiceService();

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_user_invoice",
      "/user/invoice",
      "/user/invoice",
      this.service
    );
    data.entity = { user: { realName: "" } };
    data.typesName = "uc-invoice-type";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
  };

  public newEntity() {
    const entity: Invoice = {};
    return entity;
  }
}
